import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function TermsPage() {
  return <>
      <Helmet data-id="element-507" data-mp="2k62eo0s7w0w8">
        <title data-id="element-508" data-mp="2k6vesiwo7s5e">Terms of Service - Fifth Door</title>
        <meta name="description" content="Fifth Door Terms of Service." data-id="element-509" data-mp="2k4962fy1n6ll" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-510" data-mp="2f6g2luo4kqp0" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-511" data-mp="2t6iduy1xglva" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-512" data-mp="2o75voqm042z1" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-513" data-mp="2y034g516ydkg">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-514" data-mp="37x7s69aoqh3d" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-515" data-mp="39oa6i1yn27yf" />

        <div className="absolute top-8 left-8 z-20" data-id="element-516" data-mp="3scf2uocyuqn7">
          <Link to="/" className="flex items-center gap-3" data-id="element-517" data-mp="3sfb1kewn1jcp">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-518" data-mp="18gr5qg1n2iy" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-519" data-mp="3cl5yy5g0wci7">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-520" data-mp="3hmbro39onzrq">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-521" data-mp="3vdqeymamin4l">
            TERMS OF SERVICE
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-522" data-mp="47paiwl5yrrx">
            <p className="font-bold" data-id="element-523" data-mp="2azzs5ipdh1i3">Last Updated: April 13, 2026</p>

            <p data-id="element-524" data-mp="260mz2g7wqy72">
              Please read these Terms of Service (the "Terms") and our Privacy
              Notice (https://fifthdoor.com/privacy) ("Privacy Notice")
              carefully because they govern your: (i) use of the website located
              at: https://fifthdoor.com/ (the "Site"), (ii) use of our platform
              that enables the creation of mini-games with no coding knowledge
              required and which are then hosted on the Site; (iii) playing of
              the mini-games hosted on the Site; and (iv) use of the
              corresponding mobile application ("App") which may be offered by
              Fifth Door, Inc. ("Fifth Door"). To make these Terms easier to
              read, the Site, our services and App are collectively called the
              "Services."
            </p>

            <p className="font-bold uppercase" data-id="element-525" data-mp="1n6dexo2bj89g">
              IMPORTANT NOTICE REGARDING ARBITRATION FOR U.S. CUSTOMERS: WHEN
              YOU AGREE TO THESE TERMS YOU ARE AGREEING (WITH LIMITED EXCEPTION)
              TO RESOLVE ANY DISPUTE BETWEEN YOU AND FIFTH DOOR THROUGH BINDING,
              INDIVIDUAL ARBITRATION RATHER THAN IN COURT. PLEASE REVIEW
              CAREFULLY SECTION 17 "DISPUTE RESOLUTION" BELOW FOR DETAILS
              REGARDING ARBITRATION.
            </p>

            <p data-id="element-526" data-mp="3f9r70blu603c">
              <strong data-id="element-527" data-mp="3a93ipxozrxct">Agreement to Terms.</strong> By using our Services, you
              agree to be bound by these Terms. If you don't agree to be bound
              by these Terms, do not use the Services.
            </p>

            <p data-id="element-528" data-mp="30is5fkjf4bt9">
              <strong data-id="element-529" data-mp="30i8ljya7jdcl">Privacy Notice.</strong> Please review our Privacy Notice,
              which also governs your use of the Services, for information on
              how we collect, use and share your information.
            </p>

            <p data-id="element-530" data-mp="2rgirekoxy0b4">
              <strong data-id="element-531" data-mp="2mizfvsjmo1mv">Changes to these Terms or the Services.</strong> We may
              update the Terms from time to time in our sole discretion. If we
              do, we'll let you know by posting the updated Terms on the Site,
              to the App and/or may also send other communications. It's
              important that you review the Terms whenever we update them or you
              use the Services. If you continue to use the Services after we
              have posted updated Terms it means that you accept and agree to
              the changes. If you don't agree to be bound by the changes, you
              may not use the Services anymore. Because our Services are
              evolving over time we may change or discontinue all or any part of
              the Services, at any time and without notice, at our sole
              discretion.
            </p>

            <p data-id="element-532" data-mp="s30oc77lt5kj">
              <strong data-id="element-533" data-mp="s3k87tgte417">Who May Use the Services?</strong> You may use the
              Services only if you are 13 years or older and capable of forming
              a binding contract with Fifth Door, and not otherwise barred from
              using the Services under applicable law.
            </p>

            <p data-id="element-534" data-mp="12x3s6q7gbcwp">
              <strong data-id="element-535" data-mp="12wlpbaqaa0ft">Feedback.</strong> We appreciate feedback, comments,
              ideas, proposals and suggestions for improvements to the Services
              ("Feedback"). If you choose to submit Feedback, you agree that we
              are free to use it without any restriction or compensation to you.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-536" data-mp="17p5cmzerw9xt">
              Use of Services: Free and Paid For Services.
            </p>

            <p data-id="element-537" data-mp="ezodliwndusm">
              <strong data-id="element-538" data-mp="f07vx0q7ml76">Registration and Your Information.</strong> In order to
              use the Services, you may have the ability to create an account or
              similar profile to use ("Account"). We may also allow you to
              create an Account through your account with certain third-party
              services such as Facebook, Apple, Google or Twitter (each, an "SNS
              Account"). If you choose the SNS Account option, we'll create your
              Account by extracting from your SNS Account certain personal
              information such as your name and email address and other personal
              information that your privacy settings on the SNS Account permit
              us to access. You agree that you won't misrepresent your identity,
              use any other person's image, likeness or identity, or otherwise
              provide any deceptive or misleading profile information or images
              in connection with the creation and use of your Account.
            </p>

            <p data-id="element-539" data-mp="2vktg3hud0swy">
              <strong data-id="element-540" data-mp="2vlcvaqsml37a">Accuracy of Account Information.</strong> It's important
              that you provide us with accurate, complete and up-to-date
              information for your Account, and you agree to update such
              information to keep it accurate, complete and up to date. If you
              don't, we might have to suspend or terminate your Account. You
              agree that you won't disclose your Account password to anyone and
              will use all reasonable means to secure your Account password and
              associated login credentials. You agree to notify us immediately
              of any unauthorized use of your Account, and you agree not to
              share your Account with any other person or otherwise permit any
              other person to use your Account, even on a temporary basis.
              You're responsible for all activities that occur under your
              Account, whether or not you know about them. We may take actions
              we deem reasonably necessary to prevent fraud and abuse, including
              placing restrictions on user accounts or on the amount of content
              that can be accessed from the Platform at any one time.
            </p>

            <p data-id="element-541" data-mp="ctx11bp9010f">
              <strong data-id="element-542" data-mp="cuf3wr6f1dhb">Free; Paid Versions.</strong> We may offer some of the
              Services for free and others that require payment. If you use the
              Services that we offer for free, you may only use the Services and
              any User Content you create for your personal, non-commercial
              purposes. Any commercial use of the Services or User Content
              created using the free version, including internal business use,
              distribution, sale, or other monetization, is strictly prohibited.
              For the pricing terms for the Services for which we charge
              services, please visit our pricing page, as may be posted and
              updated from time to time at: https://fifthdoor.com/pricing.
            </p>

            <p data-id="element-543" data-mp="qerpg9sbuwfi">
              <strong data-id="element-544" data-mp="qg2qi1ue1q2x">One-Time Payments and Subscriptions.</strong> If we
              require payment of a fee for use of the Services (or certain
              portions thereof) you agree to pay such fees. We may give you the
              option of making one-time payments on a transaction-by-transaction
              basis ("One-Time Payment(s)") or purchasing a subscription
              ("Subscription") for such use. Whether you make a One-Time
              Payment(s) or purchase a Subscription (each, a "Transaction"), you
              expressly authorize us (or our third-party payment processor) to
              charge you for such Transaction. We may ask you to supply
              additional information relevant to your Transaction, including
              your credit card number, the expiration date of your credit card
              and your email and postal addresses for billing and notification
              (such information, "Payment Information"). You represent and
              warrant that you have the legal right to use all payment method(s)
              represented by any such Payment Information. When you initiate a
              Transaction, you authorize us to provide your Payment Information
              to third parties so we can complete your Transaction and to charge
              your payment method for the type of Transaction you have selected
              (plus any applicable taxes and other charges). You may need to
              provide additional information to verify your identity before
              completing your Transaction (such information is included within
              the definition of Payment Information). By initiating a
              Transaction, you agree to the pricing, payment and billing
              policies applicable to such fees and charges, as posted or
              otherwise communicated to you. All payments for Transactions are
              non-refundable and non-transferable except as expressly provided
              in these Terms. All fees and applicable taxes, if any, are payable
              in United States dollars.
            </p>

            <p data-id="element-545" data-mp="2b44klstrl7a2">
              <strong data-id="element-546" data-mp="37ntt8rtbf9xa">Subscriptions.</strong> If you purchase a Subscription,
              you will be charged on a monthly or annual basis for the
              Subscription fees, plus any applicable taxes, and other charges
              ("Subscription Fee"), at the beginning of your Subscription and
              each year thereafter, at the then-current Subscription Fee. BY
              PURCHASING A SUBSCRIPTION, YOU AUTHORIZE FIFTH DOOR TO INITIATE
              RECURRING NON-REFUNDABLE PAYMENTS AS SET FORTH BELOW. If you
              purchase a Subscription, we (or our third-party payment processor)
              will automatically charge you each year on the anniversary of the
              commencement of your Subscription, using the Payment Information
              you have provided until you cancel your Subscription. If you
              purchase an annual subscription, no less than thirty (30) days and
              no more than forty (40) days before your Subscription term ends,
              or otherwise in accordance with applicable law, Fifth Door will
              send you a reminder with the then-current Subscription Fee. By
              agreeing to these Terms and electing to purchase a Subscription,
              you acknowledge that your Subscription has recurring payment
              features and you accept responsibility for all recurring payment
              obligations prior to cancellation of your Subscription by you or
              Fifth Door. Your Subscription continues until cancelled by you or
              we terminate your access to or use of the Services or Subscription
              in accordance with these Terms.
            </p>

            <p data-id="element-547" data-mp="apkj8bke7mxr">
              <strong data-id="element-548" data-mp="aq3tr77pr91r">Cancelling One-Time Payment or Subscription.</strong> YOUR
              PURCHASE IS FINAL AND YOU WILL NOT BE ABLE TO CANCEL THE PURCHASE
              AND/OR RECEIVE A REFUND OF YOUR ONE-TIME PAYMENT OR SUBSCRIPTION
              FEE AT ANY TIME. But if something unexpected happens in the course
              of completing a Transaction, we reserve the right to cancel your
              Transaction for any reason; if we cancel your Transaction we'll
              refund any payment you have already remitted to us for such
              Transaction. Without limiting the foregoing, you may cancel your
              Subscription at any time, but please note that such cancellation
              will be effective at the end of the then-current Subscription
              period. EXCEPT AS SET FORTH ABOVE WITH RESPECT TO YOUR INITIAL
              SUBSCRIPTION PURCHASE, YOU WILL NOT RECEIVE A REFUND OF ANY
              PORTION OF THE SUBSCRIPTION FEE PAID FOR THE THEN CURRENT
              SUBSCRIPTION PERIOD AT THE TIME OF CANCELLATION. To cancel, you
              can send an email to accounts@fifthdoor.com. You will be
              responsible for all Subscription Fees (plus any applicable taxes
              and other charges) incurred for the then-current Subscription
              period. If you cancel, your right to use the Services will
              continue until the end of your then current Subscription period
              and will then terminate without further charges.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-549" data-mp="7kz5evxf8vwq">Your Content / Mini-games.</p>

            <p data-id="element-550" data-mp="3lhzk1e31wr1">
              <strong data-id="element-551" data-mp="3kyfof4vgyad">Posting Content.</strong> Our Services may allow you to
              generate, store or share mini-games and other content such as text
              (in posts or communications with others), files, documents,
              graphics, images, music, software, audio and video. Anything
              (other than Feedback) that you post or otherwise make available
              through the Services is referred to as "User Content". Fifth Door
              does not claim any ownership rights in any User Content and
              nothing in these Terms will be deemed to restrict any rights that
              you may have to your User Content, except as set forth below.
            </p>

            <p data-id="element-552" data-mp="323wygdar8de7">
              <strong data-id="element-553" data-mp="2x2pr2fcixg82">Permissions to Your User Content.</strong> By making any
              User Content available through the Services you hereby grant to
              Fifth Door a non-exclusive, transferable, worldwide, royalty-free
              license, with the right to sublicense, to use, copy, modify,
              create derivative works based upon, distribute, publicly display,
              and publicly perform your User Content in connection with
              operating and providing the Services. You further acknowledge and
              agree that Fifth Door may combine or aggregate User Content with
              data from other users to create aggregated and/or deidentified so
              that it cannot reasonably be used to identify an individual person
              or organization ("Anonymized Data"), and may retain, use,
              disclose, license, sell, or otherwise provide such Anonymized Data
              to third parties, including but not limited to artificial
              intelligence research organizations and commercial model
              developers, for any purpose, including training, developing,
              evaluating, or validating machine learning models. Fifth Door may
              transfer User Content, Anonymized Data or telemetry, logs, model
              traces, and other technical or analytical information generated by
              your use of the Services to its own or third-party AI providers
              and research partners for these purposes. You waive any claim to
              royalties or other remuneration in connection with such use.
            </p>

            <p data-id="element-554" data-mp="ujb6t8v2t1cd">
              <strong data-id="element-555" data-mp="ujsyrtapgteh">Your Responsibility for User Content.</strong> You are
              solely responsible for all your User Content. You represent and
              warrant that you have (and will have) all rights that are
              necessary to grant us the license rights in your User Content
              under these Terms. You represent and warrant that neither your
              User Content, nor your use and provision of your User Content to
              be made available through the Services, nor any use of your User
              Content by Fifth Door on or through the Services will infringe,
              misappropriate or violate a third party's intellectual property
              rights, or rights of publicity or privacy, or result in the
              violation of any applicable law or regulation.
            </p>

            <p data-id="element-556" data-mp="wwwsfojmwkwu">
              <strong data-id="element-557" data-mp="wxg1efrb3yyq">Removal of User Content.</strong> You may allow you to
              remove your User Content by specifically deleting it, or in the
              case of any of your mini-games, unpublishing the game for public
              view. You should know that in certain instances, some of your User
              Content (such as posts or comments you make) may not be completely
              removed and copies of your User Content may continue to exist on
              the Services. To the maximum extent permitted by law, we are not
              responsible or liable for the removal or deletion of (or the
              failure to remove or delete) any of your User Content.
            </p>

            <p data-id="element-558" data-mp="30djp1f32q6zx">
              <strong data-id="element-559" data-mp="30d1j1qqm0eet">AI Technology Disclosure.</strong> You acknowledge that
              certain features of the Services (including the creation of
              min-games) may utilize artificial intelligence (AI) technologies,
              including but not limited to application programming interfaces
              (APIs) provided by third-party AI providers. These AI technologies
              may be used to generate, process, or analyze content within the
              Services. Due to the probabilistic nature of machine learning and
              AI, outputs generated by these technologies may be inaccurate,
              incomplete, or otherwise unreliable. Fifth Door makes no
              representations or warranties as to the accuracy, completeness, or
              suitability of any AI-generated outputs. You are solely
              responsible for reviewing and verifying any AI-generated content
              before relying on or using it, and you should use human review
              prior to any such use.
            </p>

            <p data-id="element-560" data-mp="nteh3z9fbzd3">
              <strong data-id="element-561" data-mp="nswcofclyeu3">Fifth Door's Intellectual Property.</strong> We may make
              available through the Services content that is subject to
              intellectual property rights. We retain all rights to that
              content.
            </p>

            <p data-id="element-562" data-mp="1gfz6iu6ca1e0">
              <strong data-id="element-563" data-mp="1bji919d92ao9">
                General Prohibitions and Fifth Door's Enforcement Rights.
              </strong>{' '}
              You agree not to do any of the following:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-564" data-mp="12iu5x9pe9uq5">
              <li data-id="element-565" data-mp="12i0sxqzue8zk">
                Violate any of our community guidelines that we publish, or
                post, upload, publish, submit or transmit any User Content
                (including any mini-games) that: (i) infringes, misappropriates
                or violates a third party's patent, copyright, trademark, trade
                secret, moral rights or other intellectual property rights, or
                rights of publicity or privacy; (ii) violates, or encourages any
                conduct that would violate, any applicable law or regulation or
                would give rise to civil liability; (iii) is fraudulent, false,
                misleading or deceptive; (iv) is defamatory, obscene,
                pornographic, vulgar or offensive; (v) promotes discrimination,
                bigotry, racism, hatred, harassment or harm against any
                individual or group; (vi) is violent or threatening or promotes
                violence or actions that are threatening to any person or
                entity; or (vii) promotes illegal or harmful activities or
                substances;
              </li>
              <li data-id="element-566" data-mp="152qgdjtr8vw9">
                Use, display, mirror or frame the Services or any individual
                element within the Services, Fifth Door's name, any Fifth Door
                trademark, logo or other proprietary information, or the layout
                and design of any page or form contained on a page, without
                Fifth Door's express written consent;
              </li>
              <li data-id="element-567" data-mp="2cezn4554id84">
                Access, tamper with, or use non-public areas of the Services,
                Fifth Door's computer systems, or the technical delivery systems
                of Fifth Door's providers;
              </li>
              <li data-id="element-568" data-mp="2md5o8kj3vfbx">
                Attempt to probe, scan or test the vulnerability of any Fifth
                Door system or network or breach any security or authentication
                measures;
              </li>
              <li data-id="element-569" data-mp="2w5l49caudtu6">
                Avoid, bypass, remove, deactivate, impair, descramble or
                otherwise circumvent any technological measure implemented by
                Fifth Door or any of Fifth Door's providers or any other third
                party (including another user) to protect the Services;
              </li>
              <li data-id="element-570" data-mp="3tpkzwpvfikbs">
                Attempt to access or search the Services or download content
                from the Services using any engine, software, tool, agent,
                device or mechanism (including spiders, robots, crawlers, data
                mining tools or the like) other than the software and/or search
                agents provided by Fifth Door or other generally available
                third-party web browsers;
              </li>
              <li data-id="element-571" data-mp="3as0cln8bbtta">
                Send any unsolicited or unauthorized advertising, promotional
                materials, email, junk mail, spam, chain letters or other form
                of solicitation;
              </li>
              <li data-id="element-572" data-mp="2n030dv0yazrn">
                Use any meta tags or other hidden text or metadata utilizing a
                Fifth Door trademark, logo URL or product name without Fifth
                Door's express written consent;
              </li>
              <li data-id="element-573" data-mp="2jygpji3nb09j">
                Use the Services, or any portion thereof, for any commercial
                purpose or for the benefit of any third party or in any manner
                not permitted by these Terms;
              </li>
              <li data-id="element-574" data-mp="25a3o45lsgp7n">
                Attempt to decipher, decompile, disassemble or reverse engineer
                any of the software used to provide the Services;
              </li>
              <li data-id="element-575" data-mp="2165pdw0dlgf4">
                Interfere with, or attempt to interfere with, the access of any
                user, host or network, including, without limitation, sending a
                virus, overloading, flooding, spamming, or mail-bombing the
                Services;
              </li>
              <li data-id="element-576" data-mp="1mdm121hvxdhq">
                Collect or store any personally identifiable information from
                the Services from other users of the Services without their
                express permission;
              </li>
              <li data-id="element-577" data-mp="3p6szw54nn7xa">
                Impersonate or misrepresent your affiliation with any person or
                entity;
              </li>
              <li data-id="element-578" data-mp="3t6bj8wgtvay0">Violate any applicable law or regulation; or</li>
              <li data-id="element-579" data-mp="1sxd38bwqwva">
                Encourage or enable any other individual to do any of the
                foregoing.
              </li>
            </ul>

            <p data-id="element-580" data-mp="6uegbahv6vf1">
              Fifth Door is not obligated to monitor access to or use of the
              Services or to review or edit any content. However, we have the
              right to do so for the purpose of operating the Services, to
              ensure compliance with these Terms and to comply with applicable
              law or other legal requirements. We reserve the right, but are not
              obligated, to remove or disable access to any content, including
              User Content (and any of your mini-games hosted on the Services),
              at any time and without notice, including, but not limited to, if
              we, at our sole discretion, consider it objectionable or in
              violation of these Terms. We have the right to investigate
              violations of these Terms or conduct that affects the Services. We
              may also consult and cooperate with law enforcement authorities to
              prosecute users who violate the law.
            </p>

            <p data-id="element-581" data-mp="3n7gklga68ljx">
              <strong data-id="element-582" data-mp="3n76p5d6cxm6u">DMCA/Copyright Policy.</strong> Fifth Door respects
              copyright law and expects its users to do the same. It is Fifth
              Door's policy to terminate in appropriate circumstances account
              holders who repeatedly infringe or are believed to be repeatedly
              infringing the rights of copyright holders. Please see Fifth
              Door's Copyright and IP Policy at https://fifthdoor.com/dmca, for
              further information.
            </p>

            <p data-id="element-583" data-mp="2zh2qzlbxuen8">
              <strong data-id="element-584" data-mp="2zhm7qypuqwzo">Links to Third Party Websites or Resources.</strong> The
              Services (including the App) may allow you to access third-party
              websites or other resources. We provide access only as a
              convenience and are not responsible for the content, products or
              services on or available from those resources or links displayed
              on such websites. You acknowledge sole responsibility for and
              assume all risk arising from, your use of any third-party
              resources.
            </p>

            <p data-id="element-585" data-mp="22pxizulfuspi">
              <strong data-id="element-586" data-mp="22octijdzdzyi">Beta Services.</strong> From time to time, Fifth Door may
              make available certain features, services, or functionality
              labeled or designated as alpha, beta, preview, pre-release, or
              similar ("Beta Services"). Beta Services are provided solely for
              evaluation and testing purposes, and may be modified or
              discontinued at Fifth Door's sole discretion. Beta Services are
              provided "AS IS," "AS AVAILABLE," with all faults, and without any
              warranty of any kind, whether express, implied, statutory, or
              otherwise, including any warranties of merchantability, fitness
              for a particular purpose, or non-infringement. Fifth Door does not
              guarantee that Beta Services will be free of defects or errors, or
              that they will become generally available. To the maximum extent
              permitted by law, Fifth Door's total cumulative liability for any
              and all claims arising from or relating to the Beta Services shall
              not exceed fifty dollars ($50).
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-587" data-mp="1dz8sgfw8s6rw">Rights and Terms for Apps.</p>

            <p data-id="element-588" data-mp="1dx6400aqmlpa">
              <strong data-id="element-589" data-mp="2be4kwmj72apl">App License.</strong> If you comply with these Terms,
              Fifth Door grants to you a limited non-exclusive, non-transferable
              license, with no right to sublicense, to download and install the
              App, when and if Fifth Door makes such available, on your personal
              computers, mobile handsets, tablets, wearable devices, and/or
              other devices and to run the App solely for your own personal
              non-commercial purposes. Except as expressly permitted in these
              Terms, you may not: (i) copy, modify or create derivative works
              based on the App; (ii) distribute, transfer, sublicense, lease,
              lend or rent the App to any third party; (iii) reverse engineer,
              decompile or disassemble the App (unless applicable law permits,
              despite this limitation); or (iv) make the functionality of the
              App available to multiple users through any means.
            </p>

            <p data-id="element-590" data-mp="3foxxdzu60qv3">
              <strong data-id="element-591" data-mp="3fphe5d82x97j">Additional Information: Apple App Store.</strong> This
              Section 8(b) applies to any App that you acquire from the Apple
              App Store or use on an iOS device. Apple has no obligation to
              furnish any maintenance and support services with respect to the
              App. In the event of any failure of the App to conform to any
              applicable warranty, you may notify Apple, and Apple will refund
              the App purchase price to you (if applicable) and, to the maximum
              extent permitted by applicable law, Apple will have no other
              warranty obligation whatsoever with respect to the App. Apple is
              not responsible for addressing any claims by you or any third
              party relating to the App or your possession and use of it,
              including, but not limited to: (i) product liability claims; (ii)
              any claim that the App fails to conform to any applicable legal or
              regulatory requirement; and (iii) claims arising under consumer
              protection or similar legislation. Apple is not responsible for
              the investigation, defense, settlement and discharge of any
              third-party claim that your possession and use of the App infringe
              that third party's intellectual property rights. Apple and its
              subsidiaries are third-party beneficiaries of these Terms, and
              upon your acceptance of the Terms, Apple will have the right (and
              will be deemed to have accepted the right) to enforce these Terms
              against you as a third-party beneficiary thereof. You represent
              and warrant that (i) you are not located in a country that is
              subject to a U.S. Government embargo, or that has been designated
              by the U.S. Government as a terrorist-supporting country; and (ii)
              you are not listed on any U.S. Government list of prohibited or
              restricted parties. You must also comply with any applicable
              third-party terms of service when using the App.
            </p>

            <p data-id="element-592" data-mp="3cirlhysa5rwj">
              <strong data-id="element-593" data-mp="3ch6rca9voaz7">Termination.</strong> We may suspend or terminate your
              access to and use of the Services, including suspending access to
              or terminating your account, at our sole discretion, at any time
              and without notice to you. You may cancel your account at any time
              by sending us an email at accounts@fifthdoor.com. Upon any
              termination, discontinuation or cancellation of the Services or
              your account, the following Sections will survive: 7(b), 7(c),
              7(e), 13, 14, 15, 16, 17, 18 and 19.
            </p>

            <p data-id="element-594" data-mp="32qly72cz3yno">
              <strong data-id="element-595" data-mp="32q2crbo46s4w">Warranty Disclaimers.</strong> THE SERVICES ARE PROVIDED
              "AS IS," WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE
              FOREGOING, WE EXPLICITLY DISCLAIM ANY IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT
              AND NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF
              DEALING OR USAGE OF TRADE. We make no warranty that the Services
              will meet your requirements or be available on an uninterrupted,
              secure, or error-free basis. We make no warranty regarding the
              quality, accuracy, timeliness, truthfulness, completeness or
              reliability of any information or content on the Services.
            </p>

            <p data-id="element-596" data-mp="1olsad5g4nh10">
              <strong data-id="element-597" data-mp="1omad8kxaothw">Indemnity.</strong> You will indemnify and hold Fifth Door
              and its officers, directors, employees and agents harmless from
              and against any claims, disputes, demands, liabilities, damages,
              losses, and costs and expenses, including, without limitation,
              reasonable legal and accounting fees, arising out of or in any way
              connected with (a) your access to or use of the Services, (b) your
              User Content, including any claim that your User Content
              infringes, misappropriates, or otherwise violates any third
              party's intellectual property rights, including but not limited to
              copyright, trademark, trade secret, or rights of publicity or
              privacy, or (c) your violation of these Terms.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-598" data-mp="2w54atuio65fa">Limitation of Liability.</p>

            <p className="uppercase" data-id="element-599" data-mp="2h8dlyf6mgc3x">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEITHER Fifth Door NOR ITS
              SERVICE PROVIDERS INVOLVED IN CREATING, PRODUCING, OR DELIVERING
              THE SERVICES WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY
              OR CONSEQUENTIAL DAMAGES, OR DAMAGES FOR LOST PROFITS, LOST
              REVENUES, LOST SAVINGS, LOST BUSINESS OPPORTUNITY, LOSS OF DATA OR
              GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE
              OR THE COST OF SUBSTITUTE SERVICES OF ANY KIND ARISING OUT OF OR
              IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO
              USE THE SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT
              (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL
              THEORY, AND WHETHER OR NOT Fifth Door OR ITS SERVICE PROVIDERS
              HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A
              LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS
              ESSENTIAL PURPOSE.
            </p>

            <p className="uppercase" data-id="element-600" data-mp="zbs36cpai6lq">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL FIFTH
              DOOR'S TOTAL CUMULATIVE LIABILITY TO YOU ARISING FROM ALL CLAIMS
              UNDER OR RELATED TO THESE TERMS OR FROM THE USE OF OR INABILITY TO
              USE THE SERVICES EXCEED THE AMOUNTS ACTUAL PAID BY YOU OR ARE
              PAYABLE BY YOU TO Fifth Door FOR USE OF THE SERVICES, PROVIDED
              THAT IN NO EVENT WILL Fifth Door'S TOTAL CUMULATIVE LIABILITY FOR
              ALL CLAIMS MADE UNDER OR RELATED TO THIS AGREEMENT EXCEED TWO
              HUNDRED DOLLARS $200.00.
            </p>

            <p className="uppercase" data-id="element-601" data-mp="1izrv1nyktgma">
              THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE
              FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN Fifth
              Door AND YOU.
            </p>

            <p data-id="element-602" data-mp="1wz11hvwzcwd2">
              <strong data-id="element-603" data-mp="1wzkmxmlua2vu">Governing Law and Forum Choice.</strong> These Terms and
              any action related thereto will be governed by the Federal
              Arbitration Act, federal arbitration law, and the laws of the
              State of California, without regard to its conflict of laws
              provisions. Except as otherwise expressly set forth in Section 17
              "Dispute Resolution," the exclusive jurisdiction for all Disputes
              (defined below) that you and Fifth Door are not required to
              arbitrate will be the state and federal courts located in the San
              Francisco County, and you and Fifth Door each waive any objection
              to jurisdiction and venue in such courts.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-604" data-mp="521addi2y28d">Dispute Resolution.</p>

            <p data-id="element-605" data-mp="13q8vdiey48">
              <strong data-id="element-606" data-mp="2oclxpo7ar0">Mandatory Arbitration of Disputes.</strong> We each agree
              that any dispute, claim or controversy arising out of or relating
              to these Terms or the breach, termination, enforcement,
              interpretation or validity thereof or the use of the Services
              (collectively, "Disputes") will be resolved solely by binding,
              individual arbitration and not in a class, representative or
              consolidated action or proceeding. You and Fifth Door agree that
              the U.S. Federal Arbitration Act governs the interpretation and
              enforcement of these Terms, and that you and Fifth Door are each
              waiving the right to a trial by jury or to participate in a class
              action. This arbitration provision shall survive termination of
              these Terms.
            </p>

            <p data-id="element-607" data-mp="ju8vwrbi690x">
              <strong data-id="element-608" data-mp="ju0f4oc9ejkg">Exceptions.</strong> As limited exceptions to Section
              17(a) above: (i) we both may seek to resolve a Dispute in small
              claims court if it qualifies; and (ii) we each retain the right to
              seek injunctive or other equitable relief from a court to prevent
              (or enjoin) the infringement or misappropriation of our
              intellectual property rights.
            </p>

            <p data-id="element-609" data-mp="oq7f80hz50uh">
              <strong data-id="element-610" data-mp="oqqxjibjdr91">Conducting Arbitration and Arbitration Rules.</strong> The
              arbitration will be conducted by the American Arbitration
              Association ("AAA") under its Consumer Arbitration Rules (the "AAA
              Rules") then in effect, except as modified by these Terms. The AAA
              Rules are available at www.adr.org or by calling 1-800-778-7879. A
              party who wishes to start arbitration must submit a written Demand
              for Arbitration to AAA and give notice to the other party as
              specified in the AAA Rules. The AAA provides a form Demand for
              Arbitration at www.adr.org.
            </p>

            <p data-id="element-611" data-mp="3azolc5g9pmue">
              Any arbitration hearings will take place in the county (or parish)
              where you live, unless we both agree to a different location. The
              parties agree that the arbitrator shall have exclusive authority
              to decide all issues relating to the interpretation,
              applicability, enforceability and scope of this arbitration
              agreement.
            </p>

            <p data-id="element-612" data-mp="2s62pl6tpi1jy">
              <strong data-id="element-613" data-mp="24il1pmdkbnm9">Arbitration Costs.</strong> Payment of all filing,
              administration and arbitrator fees will be governed by the AAA
              Rules, and we won't seek to recover the administration and
              arbitrator fees we are responsible for paying, unless the
              arbitrator finds your Dispute frivolous. If we prevail in
              arbitration we'll pay all of our attorneys' fees and costs and
              won't seek to recover them from you. If you prevail in arbitration
              you will be entitled to an award of attorneys' fees and expenses
              to the extent provided under applicable law.
            </p>

            <p data-id="element-614" data-mp="h2fnu6mxeo3o">
              <strong data-id="element-615" data-mp="d2x3bbz0of1d">Injunctive and Declaratory Relief.</strong> Except as
              provided in Section 17(b) above, the arbitrator shall determine
              all issues of liability on the merits of any claim asserted by
              either party and may award declaratory or injunctive relief only
              in favor of the individual party seeking relief and only to the
              extent necessary to provide relief warranted by that party's
              individual claim. To the extent that you or we prevail on a claim
              and seek public injunctive relief (that is, injunctive relief that
              has the primary purpose and effect of prohibiting unlawful acts
              that threaten future injury to the public), the entitlement to and
              extent of such relief must be litigated in a civil court of
              competent jurisdiction and not in arbitration. The parties agree
              that litigation of any issues of public injunctive relief shall be
              stayed pending the outcome of the merits of any individual claims
              in arbitration.
            </p>

            <p data-id="element-616" data-mp="2er1br0r2f642">
              <strong data-id="element-617" data-mp="2erkqy9pbzgee">Class Action Waiver.</strong> YOU AND FIFTH DOOR AGREE
              THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS
              INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
              PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further, if the
              parties' Dispute is resolved through arbitration, the arbitrator
              may not consolidate another person's claims with your claims, and
              may not otherwise preside over any form of a representative or
              class proceeding. If this specific provision is found to be
              unenforceable, then the entirety of this Dispute Resolution
              section shall be null and void.
            </p>

            <p data-id="element-618" data-mp="5jxuenvrvs46">
              <strong data-id="element-619" data-mp="5khcq5pc4iiq">Severability.</strong> With the exception of any of the
              provisions in Section 17(f) of these Terms ("Class Action
              Waiver"), if an arbitrator or court of competent jurisdiction
              decides that any part of these Terms is invalid or unenforceable,
              the other parts of these Terms will still apply.
            </p>

            <p className="font-bold text-xl mt-8" data-id="element-620" data-mp="1qxaol4ntjr41">General Terms.</p>

            <p data-id="element-621" data-mp="1queq9f8270f2">
              <strong data-id="element-622" data-mp="1lxxsrueyz9pb">Reservation of Rights.</strong> Fifth Door and its
              licensors exclusively own all right, title and interest in and to
              the Services, including all associated intellectual property
              rights. You acknowledge that the Services are protected by
              copyright, trademark, and other laws of the United States and
              foreign countries. You agree not to remove, alter or obscure any
              copyright, trademark, service mark or other proprietary rights
              notices incorporated in or accompanying the Services.
            </p>

            <p data-id="element-623" data-mp="1fgmhsn1wx4ir">
              <strong data-id="element-624" data-mp="1fih6mcgb1gs4">Entire Agreement.</strong> These Terms constitute the
              entire and exclusive understanding and agreement between Fifth
              Door and you regarding the Services, and these Terms supersede and
              replace all prior oral or written understandings or agreements
              between Fifth Door and you regarding the Services. If any
              provision of these Terms is held invalid or unenforceable by an
              arbitrator or a court of competent jurisdiction, that provision
              will be enforced to the maximum extent permissible and the other
              provisions of these Terms will remain in full force and effect.
              Except where provided by applicable law in your jurisdiction, you
              may not assign or transfer these Terms, by operation of law or
              otherwise, without Fifth Door's prior written consent. Any attempt
              by you to assign or transfer these Terms absent our consent or
              your statutory right, without such consent, will be null. Fifth
              Door may freely assign or transfer these Terms without
              restriction. Subject to the foregoing, these Terms will bind and
              inure to the benefit of the parties, their successors and
              permitted assigns.
            </p>

            <p data-id="element-625" data-mp="3w3ul812bfg6l">
              <strong data-id="element-626" data-mp="3w4e0fa0kzqgx">Notices.</strong> Any notices or other communications
              provided by Fifth Door under these Terms will be given: (i) via
              email; or (ii) by posting to the Services. For notices made by
              email, the date of receipt will be deemed the date on which such
              notice is transmitted.
            </p>

            <p data-id="element-627" data-mp="9o6pki6rt5mc">
              <strong data-id="element-628" data-mp="el5e8l7o0kd5">Waiver of Rights.</strong> Fifth Door's failure to enforce
              any right or provision of these Terms will not be considered a
              waiver of such right or provision. The waiver of any such right or
              provision will be effective only if in writing and signed by a
              duly authorized representative of Fifth Door. Except as expressly
              set forth in these Terms, the exercise by either party of any of
              its remedies under these Terms will be without prejudice to its
              other remedies under these Terms or otherwise.
            </p>

            <p data-id="element-629" data-mp="3i25hn8qmg6uk">
              <strong data-id="element-630" data-mp="3i0knhk87ypx8">Contact Information.</strong> If you have any questions
              about these Terms or the Services, please contact Fifth Door at
              accounts@fifthdoor.com.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-631" data-mp="1etda1nrbu7db" />
    </>;
}